// @flow
import Cookies from 'js-cookie';

export default class GoogleUTMZCookieParser {
	utmz: string;
	domainHash: string;
	timestamp: string;
	sessionNumber: string;
	campaignNumber: string;
	source: string;
	medium: string;
	term: string;
	content: string;
	campaign: string;
	gclid: string;

	constructor () {
		this.utmz = Cookies.get('__utmz');
		if (this.utmz) {
			this._parseUtmz();
		}
	}

	_parseUtmz () {
		const utmzCenter = this.utmz.indexOf('u');

		if (utmzCenter + 1) {
			const utmzFirstPart = this.utmz.substring(0, utmzCenter - 1);
			const utmzSecondPart = this.utmz.substring(utmzCenter);

			[
				this.domainHash,
				this.timestamp,
				this.sessionNumber,
				this.campaignNumber,
			] = utmzFirstPart.split('.');


			const getUtmzPropFromSecondPart = (searchProp) => {
				const searchPropIndex = utmzSecondPart.indexOf(searchProp);

				if (searchPropIndex + 1) {
					let str = utmzSecondPart.substring(searchPropIndex + searchProp.length + 1);

					if (str.indexOf('|u') + 1) {
						str = str.substring(0, str.indexOf('|u'));
					}
					return decodeURIComponent(str);
				}
				return null;
			};

			this.source = getUtmzPropFromSecondPart('utmcsr');
			this.medium = getUtmzPropFromSecondPart('utmcmd');
			this.term = getUtmzPropFromSecondPart('utmctr');
			this.content = getUtmzPropFromSecondPart('utmcct');
			this.campaign = getUtmzPropFromSecondPart('utmccn');
			this.gclid = getUtmzPropFromSecondPart('utmgclid');
		}
	}
}
